// extracted by mini-css-extract-plugin
export default {"ratings":"Rating_ratings__+MtHO"};